import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import App from '../bizLanding';

const BizLandingApp = (props) => (
	<BrowserRouter>
		<App {...props} />
	</BrowserRouter>
);

export default BizLandingApp;
